import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { redirectURLsService } from 'src/services/redirect-urls.service'

const useRedirectURLDelete = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (id:string) =>
      redirectURLsService.deleteRedirectURL(id),
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.REDIRECT_URLS)
        }
      },
    },
  )
}

export { useRedirectURLDelete }
